import { useRouter } from "next/router";
import { useEffect } from "react";
import { Analytics } from "../utils/core/analytics";
export var usePageSegmentAnalytics = function usePageSegmentAnalytics() {
  var router = useRouter();
  var pathname = router.pathname;
  useEffect(function () {
    Analytics.trackPage();
  }, [pathname]);
};